module.exports = __webpack_public_path__ + "static/img/2.1f2b6b51.jpg";